var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrack1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 54,
    viewBox: "0 0 130 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1776 8.60225C27.5249 3.64603 37.6291 2.61013 46.8084 5.76948L52.7482 7.81385C59.9003 10.2755 67.4991 11.1662 75.0265 10.4253L102.429 7.72823C115.591 6.43269 127 16.7738 127 30C127 36.5713 120.743 41.3377 114.407 39.5923L95.1963 34.2994C85.8499 31.7244 75.8375 33.6508 68.1139 39.5101L63.6694 42.8818C55.716 48.9154 45.6347 51.4197 35.7825 49.8092L18.5099 46.9858C9.56655 45.5239 3 37.7969 3 28.7348C3 22.2084 6.44 16.1652 12.0518 12.8332L19.1776 8.60225Z",
    stroke: "currentColor",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack1);
export default __webpack_public_path__ + "static/media/track1.598a5c3a.svg";
export { ForwardRef as ReactComponent };